export default __webpack_public_path__ + "static/media/1.4f0e36f9.jpg";